import {getPageNum, getPersonTemplateDetail} from "@/components/ExportPersonalReportModal/service";
import type {Effect, Reducer} from "@@/plugin-dva/connect";
import type { Moment } from "moment";
import type { Key } from "react";
import {getLocale} from "@@/plugin-locale/localeExports";
import moment from "moment";

export interface CreateHealthReportType {
  namespace: 'createHealthReport',
  state: CreateHealthReportState,
  effects: Record<string, Effect>,
  reducers: Record<string, Reducer>,
};
export interface pdfMergeParam{
  mergePage?: Key[];
  /*1-健康评估报告，3-小屋报告，4-体检报告*/
  sourceCode: number;
  name?: string,
  sourceId?: number;
  /*报告份数*/
  num?: number;
}
export interface TransferType {
  key: string;
  title: string;
  description?: string;
  chosen?: boolean;
}

export type CreateHealthReportState ={
  id?: number
  conclusion?: string
  name?: string
  status?: number
  dateRange?: [Moment,Moment]
  contents?: any
  medias: number[]
  basicInfoType: number[]
  focusType: number[]
  questionnaireNames: number[]
  pdfMergeParamList: Record<number, pdfMergeParam[]>
  pageNumList?:  TransferType []
};
const CreateHealthReportModal: CreateHealthReportType = {
  namespace: 'createHealthReport',
  state:{
    dateRange:[ moment().add(-1, 'y'), moment()],
    conclusion:'',
    medias:[1,2,3,4],
    basicInfoType:[1,2,3,4],
    focusType:[1,2,3,4,5,6,7],
    questionnaireNames:[],
    pdfMergeParamList:{
      1:[],
      3:[],
      4:[],
      8:[],
    },
    pageNumList:[]
  },
  effects:{
     *fetchPageNum({ payload }, { call,put}){
       const {code,data}=yield call(getPageNum,payload)
       if(code===200){
         yield put({type:"setPageNumList",
           payload:[...Array(data)].map((_,index)=>({
             key:index+1,
             title:getLocale()==='en-US'?'Page '+(index+1):`第${index+1}页`
         }))})
       }

     },
     *fetchTemplateDetail({ payload }, { call,put}){
       const {code,data}=yield call(getPersonTemplateDetail,payload)
       if(code===200) {
         yield put({type: "setState", payload: {id:data.id,...data.templateInfo[0],status:data.status}})
       }

     }
  },
  reducers:{
    setMedias (state, { payload }) {
      state.medias = payload;
    },
    setState (state, { payload }) {
      return {
        ...state,
        ...payload
      }
    },
    reset(){
      return {
        dateRange:[ moment().add(-1, 'y'), moment()],
        conclusion:'',
        medias:[1,2,3,4],
        basicInfoType:[1,2,3,4],
        focusType:[1,2,3,4,5,6,7],
        questionnaireNames:[],
        pdfMergeParamList:{
          1:[],
          3:[],
          4:[],
          9:[]
        },
        pageNumList:[]
      }
    },
    setPageNumList (state, { payload }) {
      state.pageNumList = payload;
    },
    setBasicInfoType (state, { payload }) {
      state.basicInfoType = payload;
    },
    setFocusType (state, { payload }) {
      state.focusType = payload;
    },
    setQuestionnaireIds (state, { payload }) {
      state.questionnaireNames = payload;
    },
    setPdfMergeParamList (state, { payload }) {
      state.pdfMergeParamList = {...state.pdfMergeParamList,...payload};
    },
  },
}
export default CreateHealthReportModal;
